(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[185],{

/***/ "ddrH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/widgets/event-animation/EventAnimation.jsx + 3 modules
var EventAnimation = __webpack_require__("PwF2");

// CONCATENATED MODULE: ./src/client/components/lines/event-animation-line/EventAnimationLine.jsx
var __jsx = react_default.a.createElement;




var EventAnimationLine_EventAnimationLine = function EventAnimationLine(_ref) {
  var items = _ref.items,
      title = _ref.title;
  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    "data-testid": "Line-EventAnimation"
  }, __jsx(LineTitle["a" /* LineTitle */], null, title), __jsx(EventAnimation["a" /* EventAnimation */], {
    events: items
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/event-animation/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (EventAnimationLine_EventAnimationLine);

/***/ })

}]);